import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBag = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 18,
	viewBox: "0 0 19 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_4086_19066",
		style: { maskType: "luminance" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 19,
		height: 18,
		children: /* @__PURE__ */ _jsx("path", {
			d: "M18.7856 0H0.785645V18H18.7856V0Z",
			fill: "white"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_4086_19066)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M15.4106 5.625H13.1606V3.9375C13.1606 3.04237 12.8051 2.18395 12.1721 1.551C11.5392 0.918053 10.6808 0.5625 9.78565 0.5625C8.89052 0.5625 8.03209 0.918053 7.39914 1.551C6.76625 2.18395 6.41064 3.04237 6.41064 3.9375V5.625H4.16064C3.86225 5.625 3.57613 5.7435 3.36516 5.95452C3.1542 6.16548 3.03564 6.45161 3.03564 6.75V14.625C3.03564 14.9234 3.1542 15.2095 3.36516 15.4205C3.57613 15.6314 3.86225 15.75 4.16064 15.75H15.4106C15.709 15.75 15.9952 15.6314 16.2061 15.4205C16.4171 15.2095 16.5356 14.9234 16.5356 14.625V6.75C16.5356 6.45161 16.4171 6.16548 16.2061 5.95452C15.9952 5.7435 15.709 5.625 15.4106 5.625ZM9.78565 11.5312C9.61877 11.5312 9.45565 11.4818 9.3169 11.3891C9.17815 11.2963 9.06998 11.1646 9.00613 11.0104C8.94227 10.8562 8.92556 10.6866 8.95813 10.5229C8.99064 10.3592 9.071 10.2089 9.18902 10.0909C9.30704 9.97286 9.45736 9.8925 9.62102 9.85998C9.78473 9.82741 9.95434 9.84413 10.1085 9.90798C10.2627 9.97184 10.3945 10.08 10.4872 10.2188C10.5799 10.3575 10.6294 10.5206 10.6294 10.6875C10.6294 10.9113 10.5405 11.1259 10.3823 11.2841C10.224 11.4424 10.0094 11.5312 9.78565 11.5312ZM12.0356 5.625H7.53564V3.9375C7.53564 3.34077 7.7727 2.76846 8.19468 2.34654C8.61661 1.92455 9.18891 1.6875 9.78565 1.6875C10.3824 1.6875 10.9547 1.92455 11.3767 2.34654C11.7986 2.76846 12.0356 3.34077 12.0356 3.9375V5.625Z",
			fill: "#61BB79"
		})
	})]
});
export default SvgBag;
